import { fg } from '@atlassian/jira-feature-gating';

const JiraAdminAgentM2ChampionFlowRelayProvider = {
	get(): boolean {
		return fg('jira-admin-agent-m2-champion-flow');
	},
};

export default JiraAdminAgentM2ChampionFlowRelayProvider;
